import { HelpDialog } from './HelpDialog'
import { type ShareHelpTopic, shareHelpSteps } from './help/shareHelp'
import { t } from './i18n'
import { detectPlatform } from './micHelp'

export function ShareHelpDialog({
  topic,
  onRetry,
  onDismiss,
}: {
  topic: ShareHelpTopic
  onRetry: () => Promise<void>
  onDismiss: () => void
}) {
  return (
    <HelpDialog
      title={t('share.help.title')}
      body={t('share.help.lede')}
      steps={shareHelpSteps(topic, detectPlatform().platform)}
      onRetry={onRetry}
      retryLabel={t('share.help.retry')}
      onDismiss={onDismiss}
      tone="inroom"
    />
  )
}
